<template>
  <b-container>
    <b-row class="justify-content-center align-items-center">
      <b-col class="col-sm-8 col-lg-5 col-md-6">
        <b-card>
          <h1 class="text-center">Sign Up</h1>

          <ValidationObserver ref="form" v-slot="{ handleSubmit }">
            <b-form @submit.prevent="handleSubmit(sign_up)">
              <ValidationProvider
                name="name"
                rules="required"
                v-slot="{ errors, failed }"
              >
                <b-form-input
                  v-model="customer.name"
                  type="text"
                  placeholder="Full name"
                  :class="failed ? 'error-input mt-2' : 'form-input mt-2'"
                ></b-form-input>

                <span class="form-error">{{ errors[0] }}</span>
              </ValidationProvider>

              <ValidationProvider
                name="email"
                rules="required|email"
                v-slot="{ errors, failed }"
              >
                <b-form-input
                  v-model="customer.email"
                  type="email"
                  placeholder="Email"
                  :class="failed ? 'error-input mt-2' : 'form-input mt-2'"
                ></b-form-input>

                <span class="form-error">{{ errors[0] }}</span>
              </ValidationProvider>

              <ValidationProvider
                name="contact"
                rules="required"
                v-slot="{ errors, failed }"
              >
                <b-form-input
                  v-model="customer.contact"
                  type="tel"
                  placeholder="Contact"
                  :class="failed ? 'error-input mt-2' : 'form-input mt-2'"
                ></b-form-input>

                <span class="form-error">{{ errors[0] }}</span>
              </ValidationProvider>

              <ValidationObserver>
                <ValidationProvider
                  name="password"
                  rules="required|min:6|password:@confirm"
                  v-slot="{ errors, failed }"
                >
                  <b-form-input
                    v-model="customer.password"
                    type="password"
                    placeholder="Password"
                    :class="failed ? 'error-input mt-2' : 'form-input mt-2'"
                  ></b-form-input>

                  <span class="form-error">{{ errors[0] }}</span>
                </ValidationProvider>

                <ValidationProvider
                  name="password confirmation"
                  rules="required|min:6"
                  vid="confirm"
                  v-slot="{ errors, failed }"
                >
                  <b-form-input
                    v-model="customer.password_confirmation"
                    type="password"
                    placeholder="Confirm Password"
                    :class="failed ? 'error-input mt-2' : 'form-input mt-2'"
                  ></b-form-input>

                  <span class="form-error">{{ errors[0] }}</span>
                </ValidationProvider>
              </ValidationObserver>

              <b-button type="submit" variant="primary" class="mt-4 w-100 blue-gradient">Sign Up</b-button>
            </b-form>
          </ValidationObserver>

          <div class="border-bottom mt-2 mb-2"></div>

          <div class="text-right">
            <p>Already member? <router-link to="/login">Log In</router-link></p>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

export default {
  name: 'sign_up',

  data() {
    return {
      customer: {
        name: "",
        email: "",
        contact: "",
        password: "",
        password_confirmation: "",
      },
    }
  },

  methods: {
    sign_up() {
      this.$store.dispatch('customer_signup', this.customer)
        .then(response => {
          this.$router.push({ name: 'login', params: { success_message: true } })
        })
        .catch(error => {
          this.$refs.form.setErrors(error.data.errors)
          console.log(error)
        })
    }
  },

  beforeCreate: function() {
    document.body.className = 'signup-image';
  },
}
</script>

<style scoped>
  .title {
    text-align: center;
    margin-top: 20px;
  }
  .form-input {
    border: 0;
    border-bottom: 1px solid;
  }
  .blue-gradient {
    background: linear-gradient(40deg, #979fff, #5663FF);
    border: 0;
  }
  .btn {
    height: 40px;
  }
  .row {
    height: 92vh;
  }
  .card {
    border-radius: 10px !important;
  }
  .form-error {
    color: #D9534F;
    padding: 5px;
  }
  .error-input {
    border:1px solid #D9534F
  }
</style>

